var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95459 5.75524C9.95459 5.02451 10.2449 4.3237 10.7616 3.80699C11.2783 3.29028 11.9791 3 12.7098 3H18.2203C18.403 3 18.5782 3.07257 18.7074 3.20175C18.8366 3.33093 18.9091 3.50613 18.9091 3.68881V14.7098C18.9091 14.8925 18.8366 15.0677 18.7074 15.1969C18.5782 15.326 18.403 15.3986 18.2203 15.3986H12.7098C11.9791 15.3986 11.2783 15.6889 10.7616 16.2056C10.2449 16.7223 9.95459 17.4231 9.95459 18.1538",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.7098C1 14.8925 1.07257 15.0677 1.20175 15.1969C1.33093 15.326 1.50613 15.3986 1.68881 15.3986H7.1993C7.93004 15.3986 8.63084 15.6889 9.14755 16.2056C9.66426 16.7223 9.95455 17.4231 9.95455 18.1538V5.75524C9.95455 5.02451 9.66426 4.3237 9.14755 3.80699C8.63084 3.29028 7.93004 3 7.1993 3H1.68881C1.50613 3 1.33093 3.07257 1.20175 3.20175C1.07257 3.33093 1 3.50613 1 3.68881V14.7098Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.ba1fa1e2d7187b56b3ffbbc13ee0f4d6.svg";
export { ForwardRef as ReactComponent };